import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'app/core/core.module';
import { CalendarLegendCustomerComponent } from 'app/modules/calendar/orders/calendar-legend-customer/calendar-legend-customer.component';
import { CalendarOrdersPageContainer } from 'app/modules/calendar/orders/calendar-orders-page-container/calendar-orders-page.container';
import { CalendarCreateRelocationModalComponent } from 'app/modules/calendar/relocations/calendar-create-relocation-modal/calendar-create-relocation-modal.component';
import { CalendarRelocationsPageContainer } from 'app/modules/calendar/relocations/calendar-relocations-page-container/calendar-relocations-page.container';
import { AngularMaterialModule, SharedModule } from 'app/shared';

import { DragDropModule } from '@angular/cdk/drag-drop';
import { CalendarFlorderInfoListComponent } from 'app/modules/calendar/common/calendar-calendar/calendar-florder-info-list.component';
import { CalendarMonthComponent } from 'app/modules/calendar/common/calendar-calendar/calendar-month.component';
import { CalendarOrderTooltipContainer } from 'app/modules/calendar/orders/calendar-tooltip/calendar-order-tooltip.container';
import { CalendarRelocationTooltipContainer } from 'app/modules/calendar/relocations/calendar-tooltip/calendar-relocation-tooltip.container';
import { OrderModule } from '../order/order.module';
import { OrdersModule } from '../orders/orders.module';
import { RelocationModule } from '../relocation/relocation.module';
import { CalendarRoutingModule } from './calendar-routing.module';
import { CalendarDayComponent } from './common/calendar-calendar/calendar-day.component';
import { CalendarDraggableTemplatesComponent, TemplateNameFilterPipe } from './common/calendar-draggable-templates/calendar-draggable-templates.component';
import { CalendarCreateOrderModalComponent } from './orders/calendar-create-order-modal/calendar-create-order-modal.component';
import { CalendarFilterComponent } from './orders/calendar-filter/calendar-filter.component';
import { CalendarLegendComponent } from './orders/calendar-legend/calendar-legend.component';

@NgModule({
  imports: [CommonModule, CalendarRoutingModule, OrdersModule, RelocationModule, SharedModule, AngularMaterialModule, CoreModule, ReactiveFormsModule, DragDropModule, OrderModule],
  declarations: [
    CalendarOrdersPageContainer,
    CalendarRelocationsPageContainer,
    CalendarFilterComponent,
    TemplateNameFilterPipe,
    CalendarDraggableTemplatesComponent,
    CalendarMonthComponent,
    CalendarDayComponent,
    CalendarFlorderInfoListComponent,
    CalendarOrderTooltipContainer,
    CalendarRelocationTooltipContainer,
    CalendarCreateOrderModalComponent,
    CalendarCreateRelocationModalComponent,
    CalendarLegendComponent,
    CalendarLegendCustomerComponent,
  ],
})
export class CalendarModule {
}
